import type { Map as MapLibreMap } from 'maplibre-gl'
import type { HazardType } from '../types/cap'

const ICON_SIZE = 40

// Each icon: coloured disc + white symbol, 40×40px viewBox
const HAZARD_SVGS: Record<HazardType, string> = {
  fire: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
    <circle cx="20" cy="20" r="19" fill="#F97316"/>
    <path fill="white" d="M20 33c-4.4 0-8-3.3-8-8 0-4.5 3.4-7.3 5-8.8 0 2 1 3.3 2 4.2C19 17.5 20 14 22 10c1.2 2.5 4 5.5 4 9 0 1-.3 2-.7 2.8.7-1 .7-2.3.7-3.3 2 2 3 4.3 3 6.8 0 4.3-4 8.7-9 8.7z"/>
  </svg>`,

  flood: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
    <circle cx="20" cy="20" r="19" fill="#3B8BD4"/>
    <path fill="white" d="M20 9 L12 20c0 4.4 3.6 8 8 8s8-3.6 8-8L20 9z"/>
    <path stroke="white" stroke-width="2" fill="none" stroke-linecap="round"
          d="M10 31 Q14 28 18 31 Q22 34 26 31 Q30 28 34 31"/>
  </svg>`,

  storm: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
    <circle cx="20" cy="20" r="19" fill="#4F46E5"/>
    <path fill="white" d="M24 9 L13 23 h7 L18 31 L27 17 h-7 z"/>
  </svg>`,

  wind: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
    <circle cx="20" cy="20" r="19" fill="#0EA5E9"/>
    <path stroke="white" stroke-width="2.5" fill="none" stroke-linecap="round"
          d="M9 14 Q17 10 25 14 Q29 16 31 14 Q33 12 33 10"/>
    <path stroke="white" stroke-width="2.5" fill="none" stroke-linecap="round"
          d="M9 21 Q19 16 27 21 Q31 23 31 26 Q31 30 27 30"/>
    <path stroke="white" stroke-width="2.5" fill="none" stroke-linecap="round"
          d="M9 28 Q16 24 22 28"/>
  </svg>`,

  cold: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
    <circle cx="20" cy="20" r="19" fill="#06B6D4"/>
    <line x1="20" y1="9" x2="20" y2="31" stroke="white" stroke-width="2.5" stroke-linecap="round"/>
    <line x1="9" y1="20" x2="31" y2="20" stroke="white" stroke-width="2.5" stroke-linecap="round"/>
    <line x1="12.5" y1="12.5" x2="27.5" y2="27.5" stroke="white" stroke-width="2.5" stroke-linecap="round"/>
    <line x1="27.5" y1="12.5" x2="12.5" y2="27.5" stroke="white" stroke-width="2.5" stroke-linecap="round"/>
    <line x1="17" y1="11" x2="23" y2="11" stroke="white" stroke-width="2" stroke-linecap="round"/>
    <line x1="17" y1="29" x2="23" y2="29" stroke="white" stroke-width="2" stroke-linecap="round"/>
    <line x1="11" y1="17" x2="11" y2="23" stroke="white" stroke-width="2" stroke-linecap="round"/>
    <line x1="29" y1="17" x2="29" y2="23" stroke="white" stroke-width="2" stroke-linecap="round"/>
  </svg>`,

  heat: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
    <circle cx="20" cy="20" r="19" fill="#DC2626"/>
    <circle cx="20" cy="19" r="7" fill="white"/>
    <line x1="20" y1="8"  x2="20" y2="11" stroke="white" stroke-width="2.5" stroke-linecap="round"/>
    <line x1="20" y1="27" x2="20" y2="30" stroke="white" stroke-width="2.5" stroke-linecap="round"/>
    <line x1="8"  y1="19" x2="11" y2="19" stroke="white" stroke-width="2.5" stroke-linecap="round"/>
    <line x1="29" y1="19" x2="32" y2="19" stroke="white" stroke-width="2.5" stroke-linecap="round"/>
    <line x1="11.5" y1="11.5" x2="13.5" y2="13.5" stroke="white" stroke-width="2.5" stroke-linecap="round"/>
    <line x1="26.5" y1="24.5" x2="28.5" y2="26.5" stroke="white" stroke-width="2.5" stroke-linecap="round"/>
    <line x1="28.5" y1="11.5" x2="26.5" y2="13.5" stroke="white" stroke-width="2.5" stroke-linecap="round"/>
    <line x1="11.5" y1="26.5" x2="13.5" y2="24.5" stroke="white" stroke-width="2.5" stroke-linecap="round"/>
  </svg>`,

  weather: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
    <circle cx="20" cy="20" r="19" fill="#7F77DD"/>
    <path fill="white" d="M28 17h-1.5C25.9 13.7 22.8 11 19 11c-3.3 0-6.1 2-7.3 4.9A5.5 5.5 0 0012 27h10l-2 4 7-9h-4z"/>
  </svg>`,

  earthquake: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
    <circle cx="20" cy="20" r="19" fill="#BA7517"/>
    <polyline
      points="6,20 10,20 13,13 17,27 21,10 25,24 28,20 34,20"
      fill="none" stroke="white" stroke-width="2.5"
      stroke-linecap="round" stroke-linejoin="round"/>
  </svg>`,

  transport: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
    <circle cx="20" cy="20" r="19" fill="#2A9D8F"/>
    <rect x="9" y="15" width="22" height="13" rx="3" fill="white"/>
    <rect x="11" y="17" width="8" height="5" rx="1" fill="#2A9D8F"/>
    <rect x="21" y="17" width="8" height="5" rx="1" fill="#2A9D8F"/>
    <circle cx="13" cy="29" r="2.5" fill="#2A9D8F" stroke="white" stroke-width="1"/>
    <circle cx="27" cy="29" r="2.5" fill="#2A9D8F" stroke="white" stroke-width="1"/>
    <rect x="17" y="12" width="6" height="5" rx="1" fill="white"/>
  </svg>`,

  rescue: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
    <circle cx="20" cy="20" r="19" fill="#16A34A"/>
    <rect x="15" y="9" width="10" height="22" rx="2" fill="white"/>
    <rect x="9" y="15" width="22" height="10" rx="2" fill="white"/>
  </svg>`,

  biosecurity: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
    <circle cx="20" cy="20" r="19" fill="#78350F"/>
    <circle cx="20" cy="20" r="7" fill="white"/>
    <circle cx="20" cy="9"  r="2.2" fill="white"/>
    <circle cx="31" cy="20" r="2.2" fill="white"/>
    <circle cx="20" cy="31" r="2.2" fill="white"/>
    <circle cx="9"  cy="20" r="2.2" fill="white"/>
    <circle cx="27.8" cy="12.2" r="2.2" fill="white"/>
    <circle cx="27.8" cy="27.8" r="2.2" fill="white"/>
    <circle cx="12.2" cy="27.8" r="2.2" fill="white"/>
    <circle cx="12.2" cy="12.2" r="2.2" fill="white"/>
    <line x1="20" y1="13" x2="20" y2="11" stroke="white" stroke-width="1.6" stroke-linecap="round"/>
    <line x1="27" y1="20" x2="29" y2="20" stroke="white" stroke-width="1.6" stroke-linecap="round"/>
    <line x1="20" y1="27" x2="20" y2="29" stroke="white" stroke-width="1.6" stroke-linecap="round"/>
    <line x1="13" y1="20" x2="11" y2="20" stroke="white" stroke-width="1.6" stroke-linecap="round"/>
  </svg>`,

  other: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
    <circle cx="20" cy="20" r="19" fill="#888780"/>
    <line x1="20" y1="11" x2="20" y2="24" stroke="white" stroke-width="3.5" stroke-linecap="round"/>
    <circle cx="20" cy="30" r="2.5" fill="white"/>
  </svg>`,
}

function svgToImageData(svg: string, size: number): Promise<ImageData> {
  return new Promise((resolve, reject) => {
    const img = new Image()
    const encoded = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`
    img.onload = () => {
      const canvas = document.createElement('canvas')
      canvas.width = size
      canvas.height = size
      const ctx = canvas.getContext('2d')
      if (!ctx) { reject(new Error('no 2d context')); return }
      ctx.drawImage(img, 0, 0, size, size)
      resolve(ctx.getImageData(0, 0, size, size))
    }
    img.onerror = reject
    img.src = encoded
  })
}

export async function loadMapIcons(map: MapLibreMap): Promise<void> {
  await Promise.all(
    (Object.entries(HAZARD_SVGS) as [HazardType, string][]).map(async ([name, svg]) => {
      const imageId = `cap-icon-${name}`
      if (map.hasImage(imageId)) return
      const data = await svgToImageData(svg, ICON_SIZE)
      map.addImage(imageId, data, { pixelRatio: 1 })
    })
  )
}
